module.exports = __webpack_public_path__ + "static/media/emoji-strongly-disagree.a60b5739.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/emoji-strongly-disagree.svg
// module id = 457
// module chunks = 0